import { z } from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import type { TypedSchemaOutput } from "@/utils/utilityTypes"
import {
  emailAddressSchema,
  requiredTrimmedString,
} from "@/validation/sharedStringFieldSchemas"

const createUpdateUserFormSchema = z.object({
  firstName: requiredTrimmedString(
    "First name is required"
  ),
  lastName: requiredTrimmedString("Last name is required"),
  email: emailAddressSchema("Email is required"),
})

export type CreateUpdateUserFormOutput = TypedSchemaOutput<
  typeof createUpdateUserFormSchema
>

export const useCreateUpdateUserForm = () =>
  useForm({
    validationSchema: toTypedSchema(
      createUpdateUserFormSchema
    ),
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
    },
  })
